export const maryland = {
  "24000": "Maryland",
  "24001": "Allegany County",
  "24003": "Anne Arundel County",
  "24005": "Baltimore County",
  "24009": "Calvert County",
  "24011": "Caroline County",
  "24013": "Carroll County",
  "24015": "Cecil County",
  "24017": "Charles County",
  "24019": "Dorchester County",
  "24021": "Frederick County",
  "24023": "Garrett County",
  "24025": "Harford County",
  "24027": "Howard County",
  "24029": "Kent County",
  "24031": "Montgomery County",
  "24033": "Prince George",
  "24035": "Queen Anne",
  "24037": "St. Mary",
  "24039": "Somerset County",
  "24041": "Talbot County",
  "24043": "Washington County",
  "24045": "Wicomico County",
  "24047": "Worcester County",
  "24510": "Baltimore city",
};
